export const customButtonPalette = {
    dark: {
        backgroundColor: 'grey.2000',
        color: '#fff',
        variant: 'contained',
        border: 'none !important',
        outline: 'none !important',
    },
    light: {
        backgroundColor: '#fff',
        color: 'grey.2000',
    }
}